import { render, staticRenderFns } from "./OrderInstructionModal.vue?vue&type=template&id=07b0c82d&"
import script from "./OrderInstructionModal.vue?vue&type=script&lang=js&"
export * from "./OrderInstructionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports